<template>
  <div class="smsc-container">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="buttons-container ml-auto items-center  pb-3">
          <vs-button
            class="mt-3"
            @click="EditProfile"
          >Save</vs-button>
        </div>
      </div>
    </vx-card>
  <vx-card>
    <div class="flex flex-wrap p-3"  slot="no-body" >
      <div class="row">
        <smsc-col>
          <smsc-col-item>
            <vs-input class="w-100" label="First Name"  placeholder="First Name" v-model="first_name"/>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input class="w-100" label="Last Name"  placeholder="Last Name" v-model="last_name"/>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input class="w-100" label="Email" disabled placeholder="Email Address" type="email" v-model="info.email"/>
          </smsc-col-item>

<!--          ///-->
          <smsc-col-item>
            <vs-input class="w-100" label="Country" placeholder="Country" type="text" v-model="country_uuid"/>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input class="w-100" label="Address" placeholder="Address" type="text" v-model="address"/>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input class="w-100" label="City" placeholder="City" v-model="city"/>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input class="w-100" label="State" placeholder="State" v-model="state"/>
          </smsc-col-item>
          <smsc-col-item>
            <vs-input class="w-100" label="Zipcode" placeholder="Zipcode" v-model="zipcode"/>
          </smsc-col-item>




        </smsc-col>

      </div>
  <!--    <div>
        <span class="upload_image_span">Choose Photo</span>
        <div class="upload_image">
          <h3>Upload photo</h3>
          <button class="btn btn-info">Upload photo</button>
        </div>
      </div>-->
    </div>
  </vx-card>
  </div>
</template>

<script>

  export default {
    data:()=> ({
      info:[],
      uuid:'',
      first_name :"",
      last_name:"",
      country_uuid:"",
      address:"",
      city:"",
      state:"",
      zipcode:""
    }),
  methods:{
      CompanyUUID(){
        this.uuid = this.UserInfo.company.company_uuid
        console.log(this.UserInfo.company.company_uuid,"**********************");
      },

      GetItems(){
        let params = {
          uuid : this.uuid
        }
        this.$store.dispatch('company/GetListProfile',params).then((res)=>{
            this.info = res.contact
            this.first_name = this.info.first_name
            this.last_name = this.info.last_name
            this.country_uuid =  this.info.country_uuid
            this.address = this.info.address
            this.city = this.info.city
            this.state = this.info.state
            this.zipcode = this.info.zipcode
            // this.ShowSuccessMessage({ title: 'Success', text: 'Company status has been changed' })
        }).catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))

      },
    EditProfile(){
        let params = {
          id : this.uuid,
          contact:{
            first_name : this.first_name,
            last_name : this.last_name,
            country_uuid : this.country_uuid,
            address : this.address,
            city : this.city ,
            state : this.state,
            zipcode : this.zipcode
          }

        }
      this.$store.dispatch('company/Edit',params).then((res)=>{
        if(res.success){
            this.ShowSuccessMessage({ title: 'Success', text: 'Company status has been changed' })
            this.GetItems()
          }
        }).catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))

    },
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    }

  },
    computed: {
      UserInfo () {
        return this.$store.getters['user/GetUserInfo']
      },
    },
    mounted() {
      // this.CompanyUUID()

    },
    created() {
      this.CompanyUUID()

      this.GetItems()

      // this.$store.dispatch('auth/Auth')
      console.log(this.$store)
    },
  }
</script>
<style>

</style>
